module.exports = __webpack_public_path__ + "img/icon-today.5d1e6e36.svg";